// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YvSJ","type":"styles_type__c5u04","choices":"styles_choices__3A7GK"};